import { StatusCodes } from "http-status-codes";
import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";

import { request } from "../api";

const { get } = request;
const initialRoute = "group/member";
const { Authorization, Bearer } = AUTHORIZATION;

export const getExistsMemberEnrollemnt = async (payload: any): Promise<any> => {
	try {
		const endpoint = "member/get-exists-member-enrollment";
		const token = localStorage.getItem("@jwt");
		const member_SSN = payload.member_SSN;
		const employee_SSN = payload.employee_SSN;
		const url = `${endpoint}?member_SSN=${encodeURIComponent(member_SSN)}&employee_SSN=${encodeURIComponent(
			employee_SSN
		)}`;
		const response = await get(url, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("responseCheckforthis", result);
				return result;
			}
		}

		throw new Error();
	} catch (err) {
		throw err;
	}
};
